import React, { useRef, useState } from "react";
import { Upload, FileSpreadsheet, Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

/** Excel template download + import for a project's risks or issues. */
export const ImportControls = ({ projectId, kind, onDone }) => {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const downloadTemplate = async () => {
    try {
      const res = await api.get(`/imports/template/${kind}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${kind}-import-template.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Could not download the template");
    }
  };

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const data = new FormData();
    data.append("file", file);
    setBusy(true);
    try {
      const { data: res } = await api.post(`/projects/${projectId}/import/${kind}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.created) toast.success(`${res.created} ${kind} imported`);
      if (res.skipped) toast.error(`${res.skipped} row${res.skipped === 1 ? "" : "s"} skipped: ${res.errors.slice(0, 3).join("; ")}`);
      if (!res.created && !res.skipped) toast.error("No rows found in that workbook");
      await onDone();
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input ref={fileRef} data-testid={`import-${kind}-file`} type="file" accept=".xlsx" onChange={upload} className="hidden" />
      <Button size="sm" variant="outline" data-testid={`import-template-${kind}-btn`} onClick={downloadTemplate} className="gap-1.5">
        <FileSpreadsheet size={14} /> Template
      </Button>
      <Button size="sm" variant="outline" data-testid={`import-${kind}-btn`} disabled={busy} onClick={() => fileRef.current?.click()} className="gap-1.5">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} Import
      </Button>
    </div>
  );
};
